export default __webpack_public_path__ + "static/media/default-logo.eadf4417.png";